import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMapPin2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="map-pin-2, location"><path d="M19.5 10.15C19.5 6.06309 16.1421 2.75 12 2.75C7.85786 2.75 4.5 6.06309 4.5 10.15C4.5 14.5772 9.70599 17.6963 11.4794 21.25H12.521C14.2944 17.6963 19.5 14.5772 19.5 10.15Z" stroke="currentColor" strokeWidth="1.5"/><path d="M8.75 10.25C8.75 8.45507 10.2051 7 12 7C13.7949 7 15.25 8.45507 15.25 10.25C15.25 12.0449 13.7949 13.5 12 13.5C10.2051 13.5 8.75 12.0449 8.75 10.25Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconMapPin2;
